import React from "react";

import "@tennr/style/index.css";
import "./ResourcesPage.css";

// Universal
import { MetadataTags } from "@tennr/frontend/components/MetadataTags";
import { PageBackground } from "@tennr/frontend/components/PageBackground";
import { SiteFooter } from "@tennr/frontend/components/SiteFooter";
import { Link } from "@tanstack/react-router";

import { HeroSection } from "@tennr/frontend/sections/HeroSection";
import { Heading } from "@tennr/frontend/components/Heading";
import { EventResourceCard } from "@tennr/frontend/components/EventResourceCard";
import { ContentGrid } from "@tennr/frontend/components/ContentGrid";
// import { carouselDocument } from "@tennr/frontend/schemas/sanity/documents/carouselDocument";

const cards: any[] = [
  {
    url:"https://vimeo.com/1099964768",
    title: "Hear it from them: FloMed Infusion",
    image: "/img/resources/flomed-case-study-video-thumb.jpg",
    contentType:"video",
    video: { source: "https://vimeo.com/1099964768" }
  },
  {
    url:"https://vimeo.com/1084425588",
    title: "Using Language Models to Capture More Patients, Reduce Denials & Drive FTE Efficiency",
    image: "/img/resources/TnnerNICAWebinar.png",
    contentType:"video",
    video: { source: "https://vimeo.com/1084425588" }
  },
  {  
    url:"https://vimeo.com/1044738934",
    title: `How to see through the smoke & mirrors of "AI"`,
    image: "/img/resources/Smoke&MirrorsofAI.png",
    contentType:"video",
    video: { source: "https://vimeo.com/1044738934" }
  },
  {
    url:"https://vimeo.com/1065980978",
    title: "Tennr Refresh Event Spring 2025",
    image: "/img/resources/Spring2025TennrRefresh6.png",
    contentType:"video",
    video: { source: "https://vimeo.com/1065980978" }
  },
  {
    url:"https://vimeo.com/1082896440",
    title: "Hear it from them: NEB Medical Services",
    image: "/img/resources/CaseStudy-NEB Medical Services.png",
    contentType:"video",
    video: { source: "https://vimeo.com/1082896440" }
  },
  {
    url:"https://vimeo.com/1082896084",
    title: "Models Built for Rx Processing",
    image: "/img/resources/ModelsBuiltforRxProcessing.png",
    contentType:"video",    
    video: { source: "vimeo", videoId: "1082896084" }
  },
  {
    url:"https://vimeo.com/1082895731",
    title: "Benefits Investigation for Infusion",
    image: "/img/resources/BenefitsInvestigationforInfusion.png",
    contentType:"video",
    video: { source: "https://vimeo.com/1082895731" }
  },
  {
    url:"https://vimeo.com/1082895418",
    title: "Beating the Backlog",
    image: "/img/resources/BeatingtheBacklog.png",
    contentType:"video",
    video: { source: "https://vimeo.com/1082895418" }
  },
  {
    url:"https://vimeo.com/1082894983",
    title: "Solving ICD-10 Code Extraction",
    image: "/img/resources/SolvingICD-10CodeExtraction.png",
    contentType:"video",
    video: { source: "https://vimeo.com/1082894983" }
  },
  {
    url:"https://vimeo.com/1082893950",
    title: "Hear it from them: Independent Medical Equipment",
    image: "/img/resources/CaseStudy-IndependentMedicalEquipment.png",
    contentType:"video",
    video: { source: "https://vimeo.com/1082893950" }
  },
  {
    url:"https://vimeo.com/1082893479",
    title: "Hear it from them: Eastern MedTech",
    image: "/img/resources/CaseStudy-EasternMedtech.png",
    contentType:"video",
    video: { source: "https://vimeo.com/1082893479" }
  },
  {
    url:"https://vimeo.com/1082892915",
    title: "Hear it from them: Betternight",
    image: "/img/resources/CaseStudy-Betternight.png",
    contentType:"video",
    video: { source: "https://vimeo.com/1082892915" }
  },
  {
    url:"https://vimeo.com/1082892375",
    title: "Hear it from them: Gammie HomeCare",
    image: "/img/resources/CaseStudy-GammieHomecare.png",
    contentType:"video",
    video: { source: "https://vimeo.com/1082892375" }
  },
  {
    url:"https://vimeo.com/1082891280",
    title: "Tennr Medtrade Tech Talk",
    image: "/img/resources/TechTalkatMedtrade.png",
    contentType:"video",
    video: { source: "https://vimeo.com/1082891280" }
  },
  {
    url:"https://vimeo.com/1070192909",
    title: "Tennr Talks: E-prescribe",
    image: "/img/resources/E-Prescribe.png",
    contentType:"video",
    video: { source: "https://vimeo.com/1070192909" }
  },
  {
    url:"https://vimeo.com/1055292636",
    title: "Solving the Patient Processing Problem",
    image: "/img/resources/NHIAWebinar.png",
    contentType:"video",
    video: { source: "https://vimeo.com/1055292636" }
  },
  { 
    url:"https://vimeo.com/1043754597",
    title: "Tennr Refesh Event Winter 2024",
    image: "/img/resources/Refresh-Winter2024.png",
    contentType:"video",
    video: { source: "https://vimeo.com/1043754597" }
  },
  { 
    url:"https://vimeo.com/1031179303",
    title: "Hear it from them: NMA",
    image: "/img/resources/CaseStudy-NMA.png",
    contentType:"video",
    video: { source: "https://vimeo.com/1031179303" }
  },
  { 
    url:"https://vimeo.com/1022176884",
    title: "Hear it from them: Total Therapy",
    image: "/img/resources/CaseStudy-TotalTherapy.png",
    contentType:"video",
    video: { source: "https://vimeo.com/1022176884" }
  },
  {
    url: "https://23158831.fs1.hubspotusercontent-na1.net/hubfs/23158831/Sales%20Enablement%20Content/Agentic%20AI%20White%20Paper.pdf",
    title: `"Agentic" AI Solutions in Healthcare: The Gap Between the Buzz and the Reality`,
    contentType: "Whitepaper"
  }
];
export const ResourcesPage: React.FC = () => {
  return (
    <>
      <MetadataTags
        title="Resources | Tennr"
        description="Explore Tennr's content library, featuring videos, whitepapers, webinars, and more."
        imageUrl="https://tennr.com/share_cards/sharecard.png"
      />
      <main className="resources-page">
        <PageBackground bgImage="/img/resources-hero-bg.jpg" bgImageVert="/img/resources-hero-bg-vert.jpg" />
        <HeroSection
          noAnimate={true}
          className="bottom-left"
          cmsContent={{
            heading: {
              title: "Resource center",
              heading: "Work smarter with Tennr",
              body: "Explore Tennr's content library, featuring videos, whitepapers, webinars, and more.",
            },
          }}
        />
        <section className="resources-grid">
          <ContentGrid className="four-two-col three-col" gridGap="28px 26px">
            {[...cards].map((card, ix) => (
              <EventResourceCard {...card} key={`resources-card-${ix}`}/>
            ))}
          </ContentGrid>
        </section>
      </main>
      <SiteFooter bgImage="/img/footer-bg.jpg" bgImageVert="/img/footer-bg-vert.jpg" />
    </>
  );
};
